module.exports = __webpack_public_path__ + "cfca7fcc3380e4a5468c17618026d7f9.MP3";